"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCheckboxFields = exports.DefaultFields = void 0;
exports.DefaultFields = [
    "firstName",
    "lastName",
    "email",
    "phone",
    "countryCode",
    "zip",
    "terms",
    "sms",
    "customTerms",
    "customAgreement",
];
exports.DefaultCheckboxFields = [
    "terms",
    "sms",
    "customTerms",
    "customAgreement",
];
//# sourceMappingURL=default-fields.js.map